import { Injectable, Inject } from '@angular/core';
import { AppMetaDataService, EthosUserEntity } from 'src/app/meta-data/app-meta-data.service';
import { DwQueryHelper, DwOrmDataServiceToken, DwOrmDataService, DwCacheService } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PayJobChangeService {
  constructor(@Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    private cacheUtil: DwCacheService
  ) { }

  /**
   * Loads an ETHOS user and caches the results
   * @param userId user Id
   */
  getEthosUser(userId: number): Observable<EthosUserEntity> {
    if (!userId) {
      return of(null);
    }
    const key = `EthosUser_${userId}`;

    return this.cacheUtil.get(key, this.loadEthosUser(userId));
  }

  /**
   * Pure load method for an ETHOS User
   * @param userId user Id
   */
  private loadEthosUser(userId: number): Observable<EthosUserEntity> {
    if (!userId) {
      return null;
    }

    const md = new AppMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.EthosUser.CreateQuery();

    query.AddFilterAnd(qh.filters.Equal(md.EthosUser.UserId, userId));

    return this.dataService.executeQuerySingle(query);
  }

}
